const ApiUrl = 'https://api.zsgyyt.com';
//const ApiUrl = 'http://1.12.236.232';
const ApiModule = '/adm/';
export default {
    ApiUrl,
    ApiModule
}